import api from './api';

export const feedsApi = {
  async list(page = 1, query = '', signal, locale = 'ko') {
    const params = new URLSearchParams({ page: String(page), size: '20', locale, q: query });
    const response = await api.getPublic(`/feeds?${params}`, { signal, suppressGlobalError: true });
    return { items: response.data.data || [], ...response.data.meta?.pagination };
  },
  async hidden(query = '', signal, locale = 'ko', options = {}) {
    const params = new URLSearchParams({ q: query });
    const response = await api.getAuth(`/admin/app/feeds?${params}`, {
      ...options,
      signal,
      suppressGlobalError: true,
      headers: { 'Cache-Control': 'no-store' },
    });
    if (!Array.isArray(response.data.data)) throw Error('Invalid hidden feed list');
    // Keep full editor bodies out of the reader's query cache.
    return response.data.data
      .filter((post) => post.isHidden === true)
      .map((post) => ({
        id: post.id,
        title: locale === 'en' && post.titleEn?.trim() ? post.titleEn : post.title,
        slug: post.slug,
        imageUrl: post.imageUrl,
        createdAt: post.createdAt,
        updatedAt: post.updatedAt,
        isSponsored: post.isSponsored,
        isHidden: true,
      }));
  },
  async detail(identifier, authenticated, signal, locale = 'ko', options = {}) {
    const path = /^\d+$/.test(identifier)
      ? `/feeds/${identifier}`
      : `/feeds/by-slug/${encodeURIComponent(identifier)}`;
    const get = authenticated ? api.getAuth : api.getPublic;
    const response = await get(`${path}?locale=${locale === 'en' ? 'en' : 'ko'}`, {
      ...options,
      signal,
      suppressGlobalError: true,
      skipAuthRecovery: !authenticated,
    });
    return response.data.data;
  },
  async bookmark(id, saved, options = {}) {
    if (saved) return api.deleteAuth(`/bookmarks/feed/${id}`, options);
    return api.postAuth('/bookmarks', { itemType: 'FEED', itemId: id }, options);
  },
};
